const locale = {
	DASHBOARDS: 'Dashboard',
	DASHBOARD_USER: 'Dashboard Utente',

	COMPANY_INFO: "Informazioni sull'azienda",
	ORGANIZATION_CHART: 'Organigramma Aziendale',
	DASHBOARD_KPIS: 'Dashboard KPI',
	DASHBOARD_POWERBI_STATS: 'Statistiche PowerBI',

	REGISTRIES: 'Anagrafiche',
	MAILS: 'Indirizzi mail',
	PHONENUMBERS: 'Numeri di telefono',
	SOCIALNETWORKS: 'Social Network',

	COMMUNICATIONS_MANAGEMENT: 'Gestione Comunicazioni',
	COMMUNICATIONS: 'Comunicazioni',
	REQUESTS: 'Segnalazioni',
	LEAVE: 'Permessi',

	TRAINING: 'Employees Training',
	SKILLS: 'Skills',
	COURSES: 'Corsi',
	SALES: 'Commerciale',
	COMMERCIALCAMPAIGNS: 'Campagne Commerciali',
	OPPORTUNITIES: 'Opportunità',
	CONTRACTS: 'Contratti',
	ORDERS: 'Ordini',
	INVOICES: 'Fatture',

	MANAGEMENT: 'Gestione incarichi',
	PROJECTS: 'Progetti',
	ACTIVITIES: 'Attività',
	WORKREPORTS: 'Rapportini',
	CHRONOLOGY: 'Cronologia',
	TICKETS: 'Ticket',
	PHONECALLS: 'Telefonate',

	SYSTEM: 'Sistema',
	DOCUMENTS_FOLDERS: 'Cartelle Documenti',
	USERS: 'Utenti',
	GROUPS: 'Gruppi',
	RECYCLE_BIN: 'Cestino',
	TAGS: 'Tag',
	LOGS: 'Log di sistema',
	SYSTEM_TABLES: 'Tabelle di sistema',
	PERMISSIONS_MANAGEMENT: 'Gestione permessi',
	SETTINGS: 'Impostazioni'
};

export default locale;
